module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('tabs', {
    attrs: {
      "current": "like",
      "theme": "dark",
      "surface": [{
        alias: 'like',
        title: '收 藏'
      }, {
        alias: 'time',
        title: '时光机'
      }, {
        alias: 'shop',
        title: '小 摊'
      }]
    },
    on: {
      "on-click": _vm.handleclick
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "34px",
      "padding-top": "130px",
      "color": "#999"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5baeaecc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/demo.vue
// module id = 254
// module chunks = 26